<div class="input-select">
    <i class="wms {{icon}} gap-icon" [title]="titleVal" *ngIf="icon"></i>
    <input type="text" class="form-control" [ngClass]="{'icon-padding-left' : icon}" [title]="titleVal" (ngModelChange)="onInputChange($event)" [(ngModel)]="selectedValue"
        placeholder="" [attr.data-identifier]="'property-'+ propertyName">
    <div class="input-group-append" dropdown>
        <button class="input-select-dropdown-btn dropdown-toggle" dropdownToggle>
            <span class="caret"></span>
        </button>
        <ul *dropdownMenu class="dropdown-menu input-select-dropdown-menu">
            <li *ngIf="lastEnteredValue" role="menuitem" (click)="handleValueChange(lastEnteredValue)">
                <a class="dropdown-item" [class.active]="selectedValue === lastEnteredValue" href="javascript:void(0)">
                    <span class="checkmark" [ngClass]="{ 'showTick': selectedValue === lastEnteredValue }"> ✔ </span> 
                    {{ lastEnteredValue }}
                </a>
            </li>
            <li role="menuitem" *ngFor="let option of options" (click)="handleValueChange(option)">
                <a class="dropdown-item" [class.active]="selectedValue === option" href="javascript:void(0)">
                    <span class="checkmark" [ngClass]="{ 'showTick': selectedValue === option }">✔</span>
                    {{ option }}
                </a>
            </li>
        </ul>
    </div>
</div>